import { createScopedDescriptor } from 'quartz/globalState/api';
// Create a silo property to store the result of the auth tool's setup
export const HUBLESS_APP_AUTH_RESULT = createScopedDescriptor('hublessAppAuthResult', 'EXECUTION_CONTEXT');